/* eslint-disable no-undef */
import jwtDecode from "jwt-decode";
import {
  TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  TIEMPO_VALIDACION_PRORROGA_REFRESH_TOKEN,
  TIME_TOKEN_KEY,
} from "../../infrastructure/appConstants";

export const setToken = (token, refreshToken) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const getJwt = () => localStorage.getItem(TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
// set y get para la variable de la fecha
export const setTimeToken = (time)=> localStorage.setItem(TIME_TOKEN_KEY,time);

export const getTimeToken = ()=> localStorage.getItem(TIME_TOKEN_KEY);
// funcion para setear la fecha
export const getDateTimeToken = ()=>{
  const dateNow = new Date();
  const dateToken = new Date(dateNow.getTime() + 15 * 60 * 1000);
  const unixSeconds = Math.floor(dateToken.getTime() / 1000);
  setTimeToken(unixSeconds);
  return unixSeconds;
}

//
export const getDecodedToken = (jwt) => {
  try {
    return jwtDecode(jwt);
  } catch (error) {
    return null;
  }
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TIME_TOKEN_KEY);
};

export const getFechaExpiracionToken = () => {
  /* let tokenDecoded = getDecodedToken(getJwt());
  if (tokenDecoded) {
    return new Date(tokenDecoded.exp * 1000);
    //return Date.now() + 5000;
  } */
  if(!localStorage.getItem(TIME_TOKEN_KEY)){
    getDateTimeToken();
  }
  let tokenDecoded = getTimeToken();
  if (tokenDecoded) {
    return new Date(tokenDecoded * 1000);
  }
};

export const getFechaExpiracionRefreshToken = () => {
  /* let tokenDecoded = getDecodedToken(getRefreshToken());
  if (tokenDecoded) {
    return new Date(tokenDecoded.exp * 1000);
    //return Date.now() + 5000;
  } */
  if(!localStorage.getItem(TIME_TOKEN_KEY)){
    getDateTimeToken();
  }
  let tokenDecoded = getTimeToken();
  if (tokenDecoded) {
    return new Date(tokenDecoded * 1000);
  }
};

/**
 * Metodo que permite validar la fecha de expiracion del refresh token
 * True = Si el token todavia no expira
 * False = Si el token ya expiro
 */
export const validarFechaExpiracionRefrehToken = () => {
  const fechaExpiracionToken = getFechaExpiracionRefreshToken();
  if (fechaExpiracionToken) {
    return fechaExpiracionToken > Date.now();
  } else {
    return false;
  }
};

/**
 * Metodo que permite validar la fecha de expiracion del token
 * True = Si el token todavia no expira
 * False = Si el token ya expiro
 */
export const validarFechaExpiracionToken = () => {
  const fechaExpiracionToken = getFechaExpiracionToken();
  if (fechaExpiracionToken) {
    return fechaExpiracionToken > Date.now();
  } else {
    return false;
  }
};

/**
 * Metodo que permite validar el tiempo de expiracion del refresh token.
 * Si el tiempo de expiracion es menor al tiempo de validacion, al usuario se le muestra sesion finalizada
 * Sino se le muestra el dialogo que permite refrescar el token
 * True = Muestra Modal para refrescar token
 * False = Muestra Modal de sesion finalizada
 */
export const validarFechaExpiracionRefrehTokenProrroga = () => {
  const fechaExpiracionToken = getFechaExpiracionRefreshToken();
  if (fechaExpiracionToken) {
    let segundosPendientes =
      fechaExpiracionToken.getTime() - new Date().getTime();
    if (segundosPendientes >= TIEMPO_VALIDACION_PRORROGA_REFRESH_TOKEN) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
